module.exports = __webpack_public_path__ + "static/img/women-working.397f8b4c.png";